import { GlassPanel } from '../common/GlassPanel';
import { AudioLevelMeter } from './AudioLevelMeter';
import { DeviceSelect } from './DeviceSelect';

interface AudioSettingsPanelProps {
  microphones: { deviceId: string; label: string }[];
  speakers: { deviceId: string; label: string }[];
  selectedMicrophone: string;
  selectedSpeaker: string;
  onSelectMicrophone: (id: string) => void;
  onSelectSpeaker: (id: string) => void;
  audioLevel: number;
}

/**
 * Panel for audio device configuration.
 */
export function AudioSettingsPanel({
  microphones,
  speakers,
  selectedMicrophone,
  selectedSpeaker,
  onSelectMicrophone,
  onSelectSpeaker,
  audioLevel,
}: AudioSettingsPanelProps) {
  return (
    <GlassPanel variant="strong" className="space-y-6">
      <div>
        <h2 className="text-xl font-semibold">Audio</h2>
        <p className="text-ink-200 text-sm">
          Choose your microphone and speaker, then confirm input levels.
        </p>
      </div>
      <DeviceSelect
        label="Microphone"
        devices={microphones}
        selectedId={selectedMicrophone}
        onSelect={onSelectMicrophone}
      />
      <DeviceSelect
        label="Speaker"
        devices={speakers}
        selectedId={selectedSpeaker}
        onSelect={onSelectSpeaker}
      />
      <AudioLevelMeter level={audioLevel} />
    </GlassPanel>
  );
}
